import { render, staticRenderFns } from "./Permissoes.vue?vue&type=template&id=7f8e486b&scoped=true"
import script from "./Permissoes.vue?vue&type=script&lang=js"
export * from "./Permissoes.vue?vue&type=script&lang=js"
import style0 from "./Permissoes.vue?vue&type=style&index=0&id=7f8e486b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8e486b",
  null
  
)

export default component.exports